export enum StoriesFolderUserPermEnum {
  Owner = "Owner",
  Editor = "Editor",
}

export interface IStoriesFolderUser {
  oktaId: string;
  status: StoriesFolderUserPermEnum;
}

export interface IStoriesFolder {
  _id: string;
  createdAt: string;
  name: string;
  openAccess?: boolean;
  orgId: string;
  order: number;
  parentId?: string | null;
  updatedAt: string;
  users: IStoriesFolderUser[];
}
